export default __webpack_public_path__ + "locales/ko-KR/Ldap.json?hash=7d558fb2300d4565f9f4554f6c2041b1";